module.exports = __webpack_public_path__ + "img/bg_bet2.d5cd1e83.png";